export default __webpack_public_path__ + "static/media/Foundry.90f568f8.png";